import { useCallback } from 'react';

import { AdsPlatform } from 'types/enums/AdsPlatform';

import { useMedia } from './useMedia';

export const useAdsPlatform = () => {
  const { isDefault, isTabletForAdsBanner } = useMedia();

  const getAdsPlatform = useCallback(() => {
    if (isDefault) {
      return AdsPlatform.Default;
    }
    if (isTabletForAdsBanner) {
      return AdsPlatform.Tablet;
    }

    return AdsPlatform.Mobile;
  }, [isDefault, isTabletForAdsBanner]);

  return {
    getAdsPlatform,
  };
};
